/**
 * @description Pushes event to dataLayer
 * @param { String } category - event "category"
 * @param { String } action - event "action"
 * @param { String } label - event "label"
 * @example analyticsEvent('Button', 'click', 'Play');
 */
export const analyticsEvent = (category, action, label) => {
    if (category && action && label) {
        const dataLayer = window.dataLayer || [];

        dataLayer.push({
            event: 'eventTracking',
            target: category,
            action,
            'target-properties': label
        });
    }
};

/**
 * @description Adds [data-event] event handler, which pushes event to dataLayer, according to element data-attributes.
 *
 * This function applied only to DOM-nodes which are suitable to '[data-event][data-event-category][data-event-label]' querySelector.
 */
export const registerAnalytics = () => {
    const trackingElements = document.querySelectorAll('[data-event][data-event-category][data-event-label]');

    if (trackingElements.length > 0) {
        trackingElements.forEach((trackingElem) => trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
            analyticsEvent(
                trackingElem.getAttribute('data-event-category'),
                trackingElem.getAttribute('data-event'),
                trackingElem.getAttribute('data-event-label')
            );
        }));
    }
};
